import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import AddTimeOffContainer from './AddTimeOffContainer'


const AddTimeOffRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><AddTimeOffContainer></AddTimeOffContainer></Provider>
}

AddTimeOffRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default AddTimeOffRoot
